import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {StorageService} from '../../../../services/storage/storage.service';
import {CartService} from '../../../../services/cart/cart.service';
import {TicketSelectComponent} from '../ticket-select/ticket-select.component';
import {Subscription} from 'rxjs';
import {EventPurchaseComponent} from '../event-purchase.component';
import {Event} from '../../../../generated/sales-terminal-client';

@Component({
  selector: 'app-ticket-select-header',
  templateUrl: './ticket-select-header.component.html',
  styleUrls: ['./ticket-select-header.component.scss']
})
export class TicketSelectHeaderComponent implements OnInit, OnDestroy {
  public static STORAGE_EVENT_PURCHASE_SELECTED_VIEW = 'eventPurchase.selectedView';
  public static VIEW_SECTORS = 'sections';
  public static VIEW_TICKETS = 'tickets';
  public viewType = {
    VIEW_SECTORS: TicketSelectHeaderComponent.VIEW_SECTORS,
    VIEW_TICKETS: TicketSelectHeaderComponent.VIEW_TICKETS
  };
  private _selectedViewSubscription: Subscription;

  @Input() event: Event;
  @Input() selectedView: string = TicketSelectHeaderComponent.VIEW_SECTORS;
  @Input() enabledSectorIds: number[] = [];
  @Input() showPromocode: boolean;

  @Output() selectedViewChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() sectorSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() promocodeChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor(public cartService: CartService,
              private storageService: StorageService) {}

  public ngOnInit(): void {
    this._selectedViewSubscription = this.storageService.changes.subscribe(({key, value}) => {
      if (key === TicketSelectHeaderComponent.STORAGE_EVENT_PURCHASE_SELECTED_VIEW) {
        this.selectedView = value;
        this.selectedViewChange.emit(this.selectedView);
      }
    });
  }
  public ngOnDestroy(): void {
    this._selectedViewSubscription.unsubscribe();
  }

  public handleViewSwitch(): void {
    this.storageService.set(TicketSelectHeaderComponent.STORAGE_EVENT_PURCHASE_SELECTED_VIEW, this.selectedView);
    if (this.selectedView !== TicketSelectHeaderComponent.VIEW_SECTORS) {
      this.sectorSelected.emit(this.storageService.get(TicketSelectComponent.STORAGE_EVENT_PURCHASE_SELECTED_SECTOR));
    } else {
      this.sectorSelected.emit(null);
    }
  }

  public get hasSelectedSection(): boolean {
    const storedEvent: number = +this.storageService.get(EventPurchaseComponent.STORAGE_EVENT_PURCHASE_ID);
    return (storedEvent === this.event.eventId) && !!(+this.storageService.get(TicketSelectComponent.STORAGE_EVENT_PURCHASE_SELECTED_SECTOR));
  }

}
